var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5288 6.29242C12.5288 2.94775 15.2402 0.236359 18.5848 0.236359H31.5621C34.9068 0.236359 37.6182 2.94775 37.6182 6.29242L38 6.29242C43.5228 6.29242 48 10.7696 48 16.2924V31.7636C48 37.2865 43.5228 41.7636 38 41.7636H10.4166C4.89377 41.7636 0.416626 37.2865 0.416626 31.7636V16.2924C0.416626 10.7696 4.89378 6.29242 10.4166 6.29242L12.5288 6.29242ZM24.4836 33.2694C29.9567 33.2694 34.3935 28.8326 34.3935 23.3595C34.3935 17.8864 29.9567 13.4496 24.4836 13.4496C19.0105 13.4496 14.5737 17.8864 14.5737 23.3595C14.5737 28.8326 19.0105 33.2694 24.4836 33.2694Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPhotography);
export default __webpack_public_path__ + "react/media/category-photography.08acc9ad67ae7740aa48e3245accad3e.svg";
export { ForwardRef as ReactComponent };